import { render, staticRenderFns } from "./OutfitDialog.vue?vue&type=template&id=4b553602&"
import script from "./OutfitDialog.vue?vue&type=script&lang=js&"
export * from "./OutfitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports